<template>
<div id="newsletter-type" v-if="id">
  <h2>
    Newsletter Type '{{ name }}' #{{ newsletterTypeId }}
  </h2>

  <newsletter-type-nav
    :newsletterTypeId="newsletterTypeId"
  ></newsletter-type-nav>

  <table class="table">
    <tr>
      <td>
        Name
      </td>
      <td>
        {{ name }}
        <span
          class="badge badge-primary"
          v-if="auto_subscribe"
        >
          Auto-Subscribe
        </span>

        <span
          class="badge badge-warning"
          v-if="default_newsletter_type"
        >
          Default
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Description
      </td>
      <td>
        {{ description || 'No description available' }}
      </td>
    </tr>
    <tr
      v-if="parent_newsletter_type"
    >
      <td>
        Parent Newsletter
      </td>
      <td>
        <router-link
          :to="{
            name: 'newsletter_type',
            params: {
              newsletterTypeId: parent_newsletter_type.id
            }
          }"
        >
          {{ parent_newsletter_type.attributes.name }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td>
        Editor
      </td>
      <td>
        <router-link
          :to="{
            name: 'user',
            params: { userId: editorId }
          }"
        >
          User #{{ editorId }}
        </router-link>
      </td>
    </tr>
    <tr
      v-if="default_reply_email"
    >
      <td>
        Default Reply Email
      </td>
      <td>
        {{ default_reply_email }}
      </td>
    </tr>
    <tr>
      <td>
        Slug
      </td>
      <td>
        {{ slug }}
      </td>
    </tr>
    <tr>
      <td>
        Digest
      </td>
      <td>
        <span
          :class="$root.boolBadgeClass(!digest)"
        >
          {{ $root.boolText(digest) }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Digestible
      </td>
      <td>
        <span
          :class="$root.boolBadgeClass(!digestible)"
        >
          {{ $root.boolText(digestible) }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Inactive
      </td>
      <td>
        <span
          :class="$root.boolBadgeClass(!inactive)"
        >
          {{ $root.boolText(inactive) }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Visible
      </td>
      <td>
        <span
          :class="$root.boolBadgeClass(visible)"
        >
          {{ $root.boolText(visible) }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Is public?
      </td>
      <td>
        <span
          :class="$root.boolBadgeClass(is_public)"
        >
          {{ $root.boolText(is_public) }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Requires subscription?
      </td>
      <td>
        <span
          :class="$root.boolBadgeClass(!requires_subscription)"
        >
          {{ $root.boolText(requires_subscription) }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Recipient Count
      </td>
      <td>
        {{ recipient_count }}
      </td>
    </tr>
    <tr>
      <td>
        Default Subscriber Newsletter?
      </td>
      <td>
        <span
          :class="$root.boolBadgeClass(!default_newsletter_type)"
        >
          {{ $root.boolText(default_newsletter_type) }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Default Free Newsletter?
      </td>
      <td>
        <span
          :class="$root.boolBadgeClass(!default_free_newsletter_type)"
        >
          {{ $root.boolText(default_free_newsletter_type) }}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Created At
      </td>
      <td>
        {{ formatDate(created_at) }}
      </td>
    </tr>
    <tr>
      <td>
        Updated At
      </td>
      <td>
        {{ formatDate(updated_at) }}
      </td>
    </tr>
    <tr>
      <td>
        Header (HTML)
      </td>
      <td>
        <span
          v-html="header_html"
          v-if="header_html"
        ></span>
        <span
          v-else
        >
          None
        </span>
      </td>
    </tr>
    <tr>
      <td>
        Footer (HTML)
      </td>
      <td>
        <span
          v-html="footer_html"
          v-if="footer_html"
        ></span>
        <span
          v-else
        >
          None
        </span>
      </td>
    </tr>
  </table>

  <newsletter-type-digest
    v-if="digest"
  />

  <div
    class="mt-2"
  >
    <newsletter-type-subscribers
      :newsletterTypeId="id"
      hideNav
    ></newsletter-type-subscribers>
  </div>
</div>
</template>

<script>
import NewsletterTypeDigest from '@/components/NewsletterTypeDigest'
import NewsletterTypeNav from '@/components/NewsletterTypeNav'
import NewsletterTypeSubscribers from '@/components/NewsletterTypeSubscribers'
import PreviewRecipientEmail from '@/components/PreviewRecipientEmail'

import NewsletterTypeStore from '@/stores/NewsletterTypeStore'
import NewsletterTypeSubscribersStore from '@/stores/NewsletterTypeSubscribersStore'

import ProvidersMixin from '@/mixins/ProvidersMixin'

import Pagination from 'sai-vue-kaminari'

export default {
  data () {
    let state = NewsletterTypeStore.state
    state.subscribers = NewsletterTypeSubscribersStore.state

    return state
  },

  computed: {
    editorId () {
      return this.relationships.editor.id
    }
  },

  components: {
    'newsletter-type-digest': NewsletterTypeDigest,
    'newsletter-type-subscribers': NewsletterTypeSubscribers,
    'newsletter-type-nav': NewsletterTypeNav,
    'pagination': Pagination,
    'preview-email': PreviewRecipientEmail
  },

  mixins: [ ProvidersMixin ],

  props: ['newsletterTypeId'],

  created () {
    this.get()
    this.$on('searchComplete', this.onPageSuccess)
  },

  methods: {
    formatDate (d) {
      return this.$root.displayDateTimeFmt(d)
    },

    get () {
      this.apiGet(
        '/newsletter_types/' + this.newsletterTypeId,
        NewsletterTypeStore, true
      ).then(() => {
        this.providers = this.providers.map((prov) => {
          return { ...prov, ...prov.attributes }
        })

        this.sortProviders()
      })
    },

    onPageSuccess (response) {
      this.subscribers = this.processSuccess(response)
    },

    createMailingList () {
      this.$http.post(this.apiUrl(
        '/newsletter_types/' + this.newsletterTypeId + '/create_mailing_list')
      ).then((response) => {
        this.processSuccess(response, NewsletterTypeStore)
      }, this.processErrors)
    },

    syncSubscribers () {
      this.$http.post(this.apiUrl(
        '/newsletter_types/' + this.newsletterTypeId + '/sync_subscribers')
      ).then((response) => {
      }, this.processErrors)
    }
  }
}
</script>
<style>
  .container .row {
    border-top: solid 1px #dee2e6;
    padding: 1em 0;
  }

  #newsletter-type-subscriber h3 {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsletterType.vue